import React, { ErrorInfo, PropsWithChildren } from 'react';
import Card from '../card/card-wrapper';
import Button from '../button/button';
import { PureErrorBoundary } from '../';

interface Props {
	title?: string | JSX.Element;
	subtitle?: string | JSX.Element;
	description?: string | JSX.Element;
	onClick?: () => void;
	buttonText?: string;
	errorNotifier?: (error: Error, errorInfo: ErrorInfo) => void;
}

function ErrorBoundaryPage({
	title = (
		<>
			Oops...
			<br />
			something went wrong!
		</>
	),
	subtitle = (
		<>
			The page you’ve requested could not be loaded at this time.
			<br />
			Please try again later.
		</>
	),
	description,
	onClick,
	buttonText = 'Go Back',
	errorNotifier,
	children
}: PropsWithChildren<Props>) {
	return (
		<PureErrorBoundary
			onError={(error, errorInfo) => {
				errorNotifier?.(error, errorInfo);
			}}
			fallback={() => (
				<div className="error-page">
					<Card
						className="error-card"
						children={
							<>
								<h1 className="title">{title}</h1>
								<h2>{subtitle}</h2>
								{description && <h4>{description}</h4>}
								{onClick && (
									<Button
										onClick={onClick}
										className="action-button"
										danger
										type="primary"
										size="large"
									>
										{buttonText}
									</Button>
								)}
							</>
						}
					/>
				</div>
			)}
		>
			{children}
		</PureErrorBoundary>
	);
}

export default ErrorBoundaryPage;
